const ROOT = 'Token/validateToken';

export const FETCH_VALIDATION_TOKEN_REQUEST = `${ROOT}/FETCH_VALIDATION_TOKEN_REQUEST`;
export const FETCH_VALIDATION_TOKEN_SUCCESS = `${ROOT}/FETCH_VALIDATION_TOKEN_SUCCESS`;
export const FETCH_VALIDATION_TOKEN_FAILURE = `${ROOT}/FETCH_VALIDATION_TOKEN_FAILURE`;